module.exports = __webpack_public_path__ + "img/level-2-3.08f7ecd5.png";